import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useMemo, useState } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { clearRemovesChoices, computeClearChoices } from "../../services/ClearSelections";
import { clearBallotSelectionChoices, selectBallotSelectionByElectionId, } from "../../store/ballotSelections/ballotSelectionsSlice";
import { clearIsVoted } from "../../store/extra/extraSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { SlateChangesDialog } from "./SlateChangesDialog";
/**
 * Clearing every choice of a ballot with slates: the voter first sees what
 * goes, and is told once it is done.
 */
export var useSlateClear = function (ballotStyle) {
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var selection = useAppSelector(selectBallotSelectionByElectionId(ballotStyle.election_id));
    var _a = useState(), pending = _a[0], setPending = _a[1];
    var _b = useState(false), wasCleared = _b[0], setWasCleared = _b[1];
    var contests = ballotStyle.ballot_eml.contests;
    var choices = useMemo(function () { return (selection ? computeClearChoices(contests, selection) : undefined); }, [contests, selection]);
    var canClear = !!choices && clearRemovesChoices(choices);
    useEffect(function () {
        if (canClear) {
            setWasCleared(false);
        }
    }, [canClear]);
    var handleClose = function (confirmed) {
        setPending(undefined);
        if (confirmed) {
            dispatch(clearBallotSelectionChoices({ ballotStyle: ballotStyle }));
            dispatch(clearIsVoted());
            setWasCleared(true);
        }
    };
    var feedback = (_jsxs(_Fragment, { children: [_jsx(Typography, { className: "slate-clear-status", role: "status", variant: "body2", sx: { overflowWrap: "anywhere" }, children: wasCleared && !canClear ? t("slates.clear.cleared") : null }), _jsx(SlateChangesDialog, { className: "slate-clear-dialog", pending: pending, current: selection, contests: contests, handleClose: handleClose, title: t("slates.clear.dialog.title"), content: t("slates.clear.dialog.content"), afterLabel: t("slates.clear.dialog.after"), ok: t("slates.clear.dialog.ok"), cancel: t("slates.clear.dialog.cancel") })] }));
    return {
        canClear: canClear,
        requestClear: function () {
            if (canClear) {
                setPending(choices);
            }
        },
        feedback: feedback,
    };
};
